/**
 * Achievement Screen - Progress bar + category cards
 * Skeleton build + patch rendering pattern
 */
import { ACHIEVEMENTS } from '../game/config/achievements.js';
import { t } from '../i18n/index.js';
import { onRender, getState, setInnerHTML } from './renderer.js';

let container: HTMLDivElement | null = null;

export function initAchievementScreen() {
  const content = document.getElementById('screen-content');
  if (!content) return;

  container = document.createElement('div');
  container.id = 'ach-screen';
  container.className = 'screen-panel';
  content.appendChild(container);

  onRender(renderAchievements);
}

const ACH_CATEGORIES = ['production', 'generator', 'prestige', 'click', 'golden', 'special'] as const;

function renderAchievements() {
  if (!container) return;
  const st = getState();

  const count = Object.values(st.achievements).filter(a => a.unlocked).length;
  const total = ACHIEVEMENTS.length;

  let html = '';

  // Progress bar
  const pct = total > 0 ? (count / total) * 100 : 0;
  html += `<div class="card">
    <div class="ach-progress-title">${t('ach_title')} ${count}/${total}</div>
    <div class="ach-progress-bar"><div class="ach-progress-fill" style="width:${pct}%"></div></div>
  </div>`;

  // Categories
  for (const cat of ACH_CATEGORIES) {
    const achs = ACHIEVEMENTS.filter(a => a.category === cat);
    const unl = achs.filter(a => st.achievements[a.id]?.unlocked).length;

    html += `<div class="ach-section">
      <div class="ach-cat-title">${t('ach_cat_' + cat)} (${unl}/${achs.length})</div>`;

    for (const a of achs) {
      const done = st.achievements[a.id]?.unlocked || false;
      const aName = t('ach_' + a.id) || a.name;
      const aDesc = t('ach_' + a.id + '_desc') || a.description;

      let rwTxt = '';
      if (a.reward.type === 'cps') rwTxt = `+${a.reward.value}% CPS`;
      else if (a.reward.type === 'clickPower') rwTxt = `+${a.reward.value}% ${t('ach_reward_tap')}`;
      else if (a.reward.type === 'prestigeBonus') rwTxt = `+${a.reward.value}% ${t('ach_reward_prestige')}`;
      else if (a.reward.type === 'goldenChance') rwTxt = `+${a.reward.value}% ${t('ach_reward_golden')}`;

      html += `<div class="ach-card${done ? ' ach-done' : ''}">
        <div class="ach-header">
          <span class="ach-name">${done ? '&#10003;' : '&#9744;'} ${aName}</span>
          <span class="ach-reward">${rwTxt}</span>
        </div>
        <div class="ach-desc">${aDesc}</div>
      </div>`;
    }
    html += `</div>`;
  }

  setInnerHTML(container, html);
}
